import React from 'react'
import { DashboardLayout } from '../../layouts'
import { Breadcrumb, FormRow } from '../../components'

const routes = [
  {
    name: 'Dashboard',
    route: '/dashboard'
  },
  {
    name: 'Event Tickets',
    route: '/dashboard/tickets'
  }
]

const List = () => {
  return (
    <div className="list mb-8 lg:mb-0">
      <div className="p-5" style={{background: '#f9f9f9'}}>
        <div className="mb-5">
          <p className="font-bold text-xs">Name</p>
          <p className="text-gray-444 text-sm">Gungun Nuryadin</p>
        </div>
        <div className="flex flex-wrap -mx-4 mb-2">
          <div className="w-1/2 px-4">
            <p className="font-bold text-xs">Email</p>
            <p className="text-gray-444 text-sm">ugun@gmail.com</p>
          </div>
          <div className="w-1/2 px-4">
            <p className="font-bold text-xs">Phone</p>
            <p className="text-gray-444 text-sm">+628112131311</p>
          </div>
        </div>
      </div>
      <div className="p-5">
        <div className="mb-5">
          <p className="font-bold text-xs">Name</p>
          <p className="text-gray-444 text-sm">James Rodman</p>
        </div>
        <div className="flex flex-wrap -mx-4 mb-2">
          <div className="w-1/2 px-4">
            <p className="font-bold text-xs">Email</p>
            <p className="text-gray-444 text-sm">jamesrod@gmail.com</p>
          </div>
          <div className="w-1/2 px-4">
            <p className="font-bold text-xs">Phone</p>
            <p className="text-gray-444 text-sm">+628112131222</p>
          </div>
        </div>
      </div>
      <div className="p-5" style={{background: '#f9f9f9'}}>
        <div className="mb-5">
          <p className="font-bold text-xs">Name</p>
          <p className="text-gray-444 text-sm">Ishaq Pasha</p>
        </div>
        <div className="flex flex-wrap -mx-4 mb-2">
          <div className="w-1/2 px-4">
            <p className="font-bold text-xs">Email</p>
            <p className="text-gray-444 text-sm">pashaque@gmail.com</p>
          </div>
          <div className="w-1/2 px-4">
            <p className="font-bold text-xs">Phone</p>
            <p className="text-gray-444 text-sm">+628112131221</p>
          </div>
        </div>
      </div>
    </div>
  )
}

const DashboardTicketsDetail = () => {
  return (
    <DashboardLayout title="Event Tickets">
      <div className="hidden lg:block">
        <Breadcrumb routes={routes}/>
      </div>
      <h1 className="text-lg lg:text-4xl font-primary pt-5 lg:pt-0">
        Ticket for <span className="font-bold underline">Indonesia Millenial Summit 2020</span>
      </h1>
      <hr className="mt-5 mb-8"/>
      <div className="flex flex-wrap -mx-4">
        <div className="w-full lg:w-1/3 px-4">
          <FormRow>
            <p className="font-bold mb-2 text-xs">Order Number</p>
            <p className="text-gray-444 text-sm">
              #996087991
            </p>
          </FormRow>
          <FormRow>
            <p className="font-bold mb-2 text-xs">Date and Time</p>
            <p className="text-gray-444 text-sm">
              Tue, Oct 6, 2020, 2:00 PM –<br/>
              Mon, Oct 12, 2020, 8:00 PM CAT
            </p>
          </FormRow>
          <FormRow last>
            <p className="font-bold mb-2 text-xs">Location</p>
            <p className="text-gray-444 text-sm">
              Hotel Grand Tjokro<br />
              Jalan Daan Mogot No.63<br />
              Tj. Duren Utara<br />
              Kec. Grogol petamburan, Daerah Khusus Ibukota <br />Jakarta 11470
            </p>
          </FormRow>
        </div>
        <div className="w-full lg:w-2/3 px-4">
          <p className="lg:text-lg font-bold mb-4 lg:mb-8">Guests (3)</p>
          <div className="mobile-fullwidth">
            <List />
          </div>
        </div>
      </div>
    </DashboardLayout>
  )
}

export { DashboardTicketsDetail }